import { axios } from '@/utils/dataCenterRequest'
const api = {
    retryTask: '/api/v1/download-center/retry-task/',
    getDownloadDetail: '/api/v1/download-center/task/'
}
export const retryTask = async id => axios.post(`${api.retryTask}${id}`)
export const getDownloadDetail = async id => axios.post(`${api.getDownloadDetail}${id}`)
